import type { RutaProd } from '../../../../runtime/rutas';

export default {
  ruta: '/sistema/Error/NotFound',
  documento: 'notfound',
  estado: 404,
  filas: [],
  cita: 'Controllers/ErrorController.cs:24-32; Web.config.example:91 y :103 (404 → /Error/NotFound)',
} satisfies RutaProd;
